type EnergyUsageCardProps = {
  title: string;
  usage: number;
  percentage: number;
  icon: React.ReactNode;
};

const EnergyUsageCard = ({
  title,
  usage,
  percentage,
  icon,
}: EnergyUsageCardProps) => {
  return (
    <div className="w-full h-[160px] pt bg-white shadow-lg rounded-xl flex flex-col items-center -space-y-2">
      {/* Circular progress bar */}
      <div className="relative">
        <svg className="w-24 h-24">
          <circle
            className="text-gray-300"
            strokeWidth="10"
            stroke="currentColor"
            fill="transparent"
            r="30"
            cx="50%"
            cy="50%"
            transform="rotate(-90 50 50)"
          />
          <circle
            className="text-[#f97316]"
            strokeWidth="10"
            strokeDasharray="188.4"
            strokeDashoffset={`${188.4 - (percentage / 100) * 188.4}`}
            strokeLinecap="round"
            stroke="currentColor"
            fill="transparent"
            r="30"
            cx="50%"
            cy="50%"
            transform="rotate(-90 50 50)"
          />
        </svg>
        {/* Lightbulb icon in the middle */}
        <div className="absolute inset-0 flex items-center justify-center mt-2">
          <span className="text-orange-400">
            {icon && typeof icon === "string" && <img src={icon} alt="Icon" />}
          </span>
        </div>
      </div>

      {/* Text below the icon */}
      <div className="text-center -space-y-1">
        <p className="text-l font-medium text-gray-600">{title}</p>
        <div className="flex items-end justify-center gap-1">
          <p className="text-[16px] font-bold text-[#212529]">{usage}</p>
          <p className="text-[11px] text-[#788796]">kWh</p>
        </div>
        <p className="text-[11px] text-[#788796]">{percentage}% จากทั้งหมด</p>
      </div>
    </div>
  );
};

export default EnergyUsageCard;
